export const getDataFromNativeSelect = (select: HTMLSelectElement) => {
	const options = select.querySelectorAll<HTMLOptionElement>('option')
	return Array.from(options).map((option) => ({ label: option.textContent || '', value: option.value }))
}

export const getDefaultValueFromNativeSelect = (select: HTMLSelectElement) => {
	const options = select.querySelectorAll<HTMLOptionElement>('option[selected]')
	const optionsArray = Array.from(options).map((option) => ({ label: option.textContent || '', value: option.value }))
	const firstOption = optionsArray.filter((item) => item.value === select.value)[0]
	return select.multiple ? optionsArray : { label: firstOption ? firstOption.label : '', value: select.value }
}
